export enum UserRole {
  user = 'collider_users',
  admin = 'collider_admins',
  coach = 'collider_coaches'
}
